import { setContext, setTag, setUser } from '@sentry/react'
import { useMemo } from 'react'
import { useAuth } from './useAuth'

export const useSentryContext = () => {
  const { tenant, tenantId, userId, userAttributes } = useAuth()

  const userContext = useMemo(
    () =>
      userAttributes
        ? ({
            ...userAttributes,
            id: userId,
            identities: undefined,
            ip_address: '{{auto}}',
          } as const)
        : null,
    [userAttributes, userId]
  )

  const tenantContext = useMemo(() => {
    if (!tenant) return null
    return {
      ...tenant,
      displayName: tenant.tenant.displayName,
      tenant: undefined,
    } as const
  }, [tenant])

  setTag('tenantId', tenantId)
  setTag('tenantAlias', tenant?.tenant.alias)
  setContext('tenant', tenantContext)
  setUser(userContext)
}
